import React from "react";
import "./CustomCheckbox.css";

interface CustomCheckboxProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  label?: string;
}

const CustomCheckbox: React.FC<CustomCheckboxProps> = ({ checked, onChange, label }) => {
  return (
    <label className="custom-checkbox">
      <input
        type="checkbox"
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
      />
      <span className="checkbox-box"></span>
      {label && <span className="checkbox-label">{label}</span>}
    </label>
  );
};

export default CustomCheckbox;
